import { writeConfigFields } from './settings-fields';

/** `PATCH /client/config/fields {payment_types}`: replaces the list. */
export const editPaymentTypes = async (payment_types: string[]): Promise<any> => {
  return writeConfigFields({ payment_types });
};
